import { faEye } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import CardDropdown from 'components/common/CardDropdown';
import FalconPagination from 'components/common/custom/pagination';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import React, { useEffect } from 'react'
import { Card, Dropdown } from 'react-bootstrap';
import { Gear } from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom';
import paths from 'routes/paths';

const PatientTableData = ({
    data,
    page,
    rowsPerPage,
    totalRows,
    handlePageChange,
    handlePerRowsChange,
    setting
}) => {
    const navigate = useNavigate();

    const columns = [
        {
            accessorKey: "index",
            header: "#",
            cell: ({ row }) => (
                <div className="d-flex align-items-center w-100">
                    <div
                        className="rounded-circle bg-200 d-flex flex-center fs-11"
                        style={{ width: "30px", height: "30px" }}
                    >
                        {page * rowsPerPage + row.index + 1}
                    </div>
                </div>
            ),
        },
        {
            accessorKey: "branch",
            header: "Branch",
            cell: ({ row: { original } }) => (
                <div className="fs-11 w-100">
                    {original?.branch || ''}
                </div>
            ),
        },
        {
            accessorKey: "patient_mrn",
            header: "MRN",
            cell: ({ row: { original } }) => (
                <div className="fs-11 w-100">
                    {original?.patient_mrn}
                </div>
            ),
        },
        {
            accessorKey: "patient_name",
            header: "Name",
            cell: ({ row: { original } }) => (
                <div className="fs-11 w-100">
                    {`${original?.patient_firstname || ''} ${original?.patient_fathername || ''} ${original?.patient_familyname || ''}`}
                </div>
            ),
        },
        {
            accessorKey: "patient_mobilenumber",
            header: "Mobile No.",
            cell: ({ row: { original } }) => (
                <div className="fs-11 w-100">
                    {original?.patient_mobilenumber}
                </div>
            ),
        },
        {
            accessorKey: "patient_emailid",
            header: "Email",
            cell: ({ row: { original } }) => (
                <div className="fs-11 w-100">
                    {original?.patient_emailid || '-'}
                </div>
            ),
        },
        {
            accessorKey: "patient_nationalid",
            header: "National ID",
            cell: ({ row: { original } }) => (
                <div className="fs-11 w-100">
                    {original?.patient_nationalid || '-'}
                </div>
            ),
        },
        {
            accessorKey: "nationality",
            header: "Nationality",
            cell: ({ row: { original } }) => (
                <div className="fs-11 w-100">
                    {original?.nationality || '-'}
                </div>
            ),
        },
        {
            accessorKey: "insurance_name",
            header: "Insurance Name",
            cell: ({ row: { original } }) => (
                <div className="fs-11 w-100">
                    {original?.insurance?.patpolcy_name || ''}
                </div>
            ),
        },
        {
            accessorKey: "insurance_no",
            header: "Insurance No.",
            cell: ({ row: { original } }) => (
                <div className="fs-11 w-100">
                    {original?.insurance?.patpolcy_number || ''}
                </div>
            ),
        },
        {
            accessorKey: "insurance_class",
            header: "Insurance Class Name",
            cell: ({ row: { original } }) => (
                <div className="fs-11 w-100">
                    {original?.insurance?.patins_clsnme || ''}
                </div>
            ),
        },
        {
            accessorKey: "insurance_network",
            header: "Insurance Network",
            cell: ({ row: { original } }) => (
                <div className="fs-11 w-100">
                    {original?.insurance?.patins_network || ''}
                </div>
            ),
        },
        {
            accessorKey: 'actions',
            header: <Gear />,
            enableSorting: false,
            cell: ({ row: { original } }) => (
                <>
                    {Number(setting?.view) === 1 && (
                        <CardDropdown
                            icon="ellipsis-v"
                            dropdownClassName="py-2 custom-dropdown-menu"
                        >
                            <Dropdown.Item onClick={() => navigate(paths.viewPatient(original?.patient_id))}>
                                <FontAwesomeIcon icon={faEye} className="me-2" />
                                View Patient
                            </Dropdown.Item>
                        </CardDropdown>
                    )}
                </>
            ),
        }
    ]

    const table = useAdvanceTable({
        data,
        columns,
        manualPagination: true,
        pageCount: Math.ceil(totalRows / rowsPerPage),
        state: {
            pagination: {
                pageIndex: page,
                pageSize: rowsPerPage,
            },
        },
    });

    useEffect(() => {
        table.setPagination({ pageIndex: page, pageSize: rowsPerPage });
    }, [page, rowsPerPage]);

    return (
        <div className='mb-3 mt-3 border'>
            {data?.length > 0 ? (
                <>
                    <AdvanceTableProvider {...table}>
                        <AdvanceTable
                            tableProps={{
                                size: "sm",
                                className: "fs-10 mb-0 overflow-hidden",
                                striped: true,
                                hover: true,
                            }}
                            headerClassName="bg-200 text-nowrap align-middle"
                            rowClassName="align-middle white-space-nowrap"
                        />
                    </AdvanceTableProvider>
                    <Card.Footer className="d-flex mt-2 mb-3 justify-content-end align-items-center">
                        <FalconPagination
                            currentPage={page}
                            rowsPerPage={rowsPerPage}
                            totalRecords={totalRows}
                            onPageChange={handlePageChange}
                            onPageSizeChange={handlePerRowsChange}
                        />
                    </Card.Footer>
                </>
            ) : (
                <div className="text-center py-3">No Data To Show</div>
            )}
        </div>
    )
}

export default PatientTableData